const baseURI = "https://www.remind.com/v1/share?";
// const flashFlowURL = "https://play.playpowerlabs.com/?fbId=BAAab3b9ss3CAaaa";
// tslint:disable-next-line:max-line-length
const flashFlowURL = "https://play.playpowerlabs.com/?fbId=BAAab3b9ss3CAaaa&activityId=b1BA232AB2B213CA&parentId=uux3GtJgt8b9E3xRlfsz&mode=prod&childName=Raj";
const textMsg = "Hey There, Share this awesome app among your friends!! ";
const remindDivID = "remind_div";
const remindAnchorID = "remind_anchor";

export default class Remind {
    private remind;
    private isRemindSetup(): boolean {
        if (window["remind"]) {
            this.remind = window["remind"];
            return true;
        }
        return false;
    }

    public renderShareButton(): void {
        // const loaderDivID = "remind-composer-iframe";
        const remindDivID = "remind_div";
        // "share-on-remind"
        let remindDiv = document.getElementById(remindDivID);
        if (remindDiv) {
            remindDiv.style.display = "block";
        }
    }
    public hideShareButton(): void {
        const remindDivID = "remind_div";
        let remindDiv = document.getElementById(remindDivID);
        if (remindDiv) {

            remindDiv.style.display = "none";
        }
    }

    public initRemind(): void {
        if (!this.isRemindSetup()) {
            return;
        } else {
            this.remind.init({
                name: "FlashFlow",
                id: "uuid-provided-by-remind"
            });
            this.handleRemindEvents();
        }
    }

    private renderComposer(): void {
        this.remind.renderComposer();
    }
    private generateURL(): string {
        let url = "";
        url = baseURI + "&url=" + encodeURIComponent(flashFlowURL) +
            "&referrer=" + window.location.href + "&text=" + textMsg;
        return url;
    }

    private handleRemindEvents(): void {

        let remindLink = document.getElementById(remindAnchorID);
        if (remindLink) {
            remindLink.setAttribute("href", this.generateURL());
        }

        this.remind.onComposerEvent(event => {
            switch (event) {
                case "Message_sent_done":
                case "message_sent_done": {
                    console.log("got the message sent done!!!!");
                }
                default:
                    break;
            }
        });
    }
}
